import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Row, Col, List, Avatar, Empty } from 'antd';
import { formatBytes, getFileImage, getFullDateHours } from 'utils/helpers';
import { ReactComponent as DownloadFile } from 'assets/icons/download_blue.svg';
import { downloadUploadedFile, openUploadedFile } from 'store/forms/actions';
import { isBeneficiary, isCoe, isSuperUser } from 'utils';
import { DownloadUpdateFile } from 'components';
import { mapDocuments } from 'store/appTrack/utils';
import styles from './documents.module.scss';

const Documents = () => {
  const dispatch = useDispatch();
  const ApplicationFilesList = useSelector(
    state => state.appTrack?.apptrackDetails?.contentItems
  );
  const apptrackDetails = useSelector(state => state.appTrack?.apptrackDetails);
  const parseFlag = apptrackDetails?.variablesIndexed?.parseFlag;
  const voucherContract = useSelector(
    state =>
      state.appTrack?.apptrackDetails?.variablesIndexed?.voucher?.contractId
  );
  const user = useSelector(state => state.user);

  // Sort without mutating original list from Redux (safe copy)
  const sortedApplicationFilesList = mapDocuments([
    ...(ApplicationFilesList || []).filter(file => file != null),
  ]).sort((a, b) => {
    const indexA = desiredOrder.indexOf(a.title);
    const indexB = desiredOrder.indexOf(b.title);

    if (indexA === -1 && indexB === -1) return 0;
    if (indexA === -1) return 1;
    if (indexB === -1) return -1;

    return indexA - indexB;
  });

  return (
    // isEmpty(!isBeneficiary(groups) ? appTrack ? ApplicationFilesList : ApplicationFilesListMainforms : ApplicationFilesList) ?
    false ? (
      <div
        style={{
          position: 'absolute',
          top: '10%',
          left: '50%',
          minHeight: '500px',
        }}
      >
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description={<>No data</>}
        />
      </div>
    ) : (
      <div style={{marginBottom: 120}} className={styles.documentsWrapper}>
        <p className="mr-0 color-purple-1 text-bold font-size-24">
          Δικαιολογητικά
        </p>

        <div className="documentsWrapper">
          <div className="documentsContent">
            {parseFlag == false && (
              <>
                {(isCoe(user.groups) || isSuperUser(user.groups)) && (
                  <div className="updateFileComponentWrapper mb-3">
                    <DownloadUpdateFile
                      type="business"
                      file={sortedApplicationFilesList.filter(
                        file => file?.items[0]?.field == 'BusinessPlan'
                      )}
                    />
                    <DownloadUpdateFile
                      type="eligibility"
                      file={sortedApplicationFilesList.filter(
                        file => file?.items[0]?.field == 'Eligibility'
                      )}
                    />
                    <DownloadUpdateFile
                      type="financial"
                      file={sortedApplicationFilesList.filter(
                        file => file?.items[0]?.field == 'FinancialModel'
                      )}
                    />
                  </div>
                )}

                {isBeneficiary(user.groups) && (
                  <div className="updateFileComponentWrapperLarge mb-3">
                    <DownloadUpdateFile
                      large
                      type="business"
                      file={sortedApplicationFilesList.filter(
                        file => file?.items[0]?.field == 'BusinessPlan'
                      )}
                    />
                    <DownloadUpdateFile
                      large
                      type="eligibility"
                      file={sortedApplicationFilesList.filter(
                        file => file?.items[0]?.field == 'Eligibility'
                      )}
                    />
                  </div>
                )}
              </>
            )}
            <Row gutter={24}>
              <Col span={24}>
                <List
                  className="applicationFilesList no-border"
                  itemLayout="vertical"
                  // dataSource={ApplicationFilesList}
                  // dataSource={!isBeneficiary(groups) ?
                  //   appTrack ?
                  //   ApplicationFilesList
                  //   : ApplicationFilesListMainforms
                  // : ApplicationFilesList}
                  dataSource={sortedApplicationFilesList.filter(
                    file =>
                      file?.items[0].field !== 'BusinessPlan' &&
                      file?.items[0].field !== 'Eligibility' &&
                      file?.items[0].field !== 'FinancialModel'
                  )}
                  renderItem={(item, index) => (
                    <div>
                      <div className="application-file-header">
                        {item?.title +
                          `${
                            item?.title.includes('Σύμβαση')
                              ? `: ${voucherContract}`
                              : ''
                          }`}
                      </div>
                      <List.Item
                        extra={item.items.map((info, index) => (
                          <div className="file-uris">
                            <div className="open-file-wrapper file-actions">
                              <a
                                className="application-open-file-text"
                                onClick={e => {
                                  e.preventDefault();
                                  dispatch(openUploadedFile(info));
                                }}
                                target={'_blank'}
                              >
                                Άνοιγμα
                              </a>
                            </div>
                            <div className="file-actions">
                              <a
                                className="application-download-file-text"
                                onClick={e => {
                                  e.preventDefault();
                                  dispatch(downloadUploadedFile(info));
                                }}
                                download={info.name}
                              >
                                <DownloadFile /> Download
                              </a>
                            </div>
                          </div>
                        ))}
                      >
                        {item.items.map((info, index) => (
                          <List.Item.Meta
                            className={index == 0 ? 'first' : ''}
                            avatar={
                              <Avatar src={getFileImage(info.simpleType)} />
                            }
                            title={
                              <div style={{ display: 'flex' }}>
                                <span className="application-file-name">
                                  {info.name}
                                </span>
                              </div>
                            }
                            description={
                              <div style={{ display: 'flex' }}>
                                <span className="application-file-size">
                                  {formatBytes(info.size)}
                                </span>
                                <span className="application-file-size">
                                  , Updated: {getFullDateHours(info.created)}
                                </span>
                              </div>
                            }
                          />
                        ))}
                      </List.Item>
                    </div>
                  )}
                />
              </Col>
            </Row>
          </div>
        </div>
      </div>
    )
  );
};

export default Documents;

const desiredOrder = [
  'Συμπληρωμένο σε Ηλεκτρονική Μορφή Excel "Δαπάνες Επένδυσης"',
  'Υπεύθυνη Δήλωση Σώρευσης',
  'Φορολογικό Έντυπο Ε3',
  'Υπεύθυνη Δήλωση Στοιχείων Πραγματικών Δικαιούχων',
  'Eκτύπωση από το Κεντρικό Μητρώο Πραγματικών Δικαιούχων',
  'Πιστοποιητικό Μεταβολών ΓΕΜΗ',
  'Άλλα Δικαιολογητικά',
];
